// PLAN-cockpit-domain-mode Phase 1 残作業 (2026-05-07〜):
// SPA 起動時に /api/schema/vocabulary/domain を fetch し、active な Domain 値一覧を取得する。
// 取得失敗時は hardcode の 5 値を fallback (起動阻害しない)。

import { useEffect, useState } from 'react'
import { apiFetch } from '../api/client'
import type { Domain } from '../types'

interface VocabularyValue {
  value: string
  label: string
  definition?: string
  status: 'active' | 'deprecated'
}

interface VocabularyResponse {
  field: string
  values: VocabularyValue[]
}

const FALLBACK_DOMAINS: Array<{ value: Domain; label: string }> = [
  { value: 'finance', label: 'Finance' },
  { value: 'relation', label: 'Relation' },
  { value: 'mind', label: 'Mind' },
  { value: 'health', label: 'Health' },
  { value: 'general', label: 'General' },
]

export interface DomainVocabulary {
  values: Array<{ value: Domain; label: string }>
  source: 'remote' | 'fallback'
  loaded: boolean
}

/**
 * SPA 起動時に Domain vocabulary を取得する hook。
 * 取得失敗時は FALLBACK_DOMAINS を返し、起動を阻害しない。
 */
export function useDomainVocabulary(): DomainVocabulary {
  const [state, setState] = useState<DomainVocabulary>({
    values: FALLBACK_DOMAINS,
    source: 'fallback',
    loaded: false,
  })

  useEffect(() => {
    let cancelled = false
    apiFetch<VocabularyResponse>('/api/schema/vocabulary/domain')
      .then((res) => {
        if (cancelled) return
        const active = (res.values ?? [])
          .filter((v) => v.status === 'active')
          .map((v) => ({ value: v.value as Domain, label: v.label }))
        if (active.length > 0) {
          setState({ values: active, source: 'remote', loaded: true })
        } else {
          setState({ values: FALLBACK_DOMAINS, source: 'fallback', loaded: true })
        }
      })
      .catch((e: unknown) => {
        if (cancelled) return
        console.warn(`[warn] Domain vocabulary fetch failed, using fallback: ${e instanceof Error ? e.message : String(e)}`)
        setState({ values: FALLBACK_DOMAINS, source: 'fallback', loaded: true })
      })
    return () => { cancelled = true }
  }, [])

  return state
}
